import { lazy } from 'react';

export const StripeaccountPage = lazy(() => import('./page-list'));
